export default "__VITE_ASSET__bd9bd6e4__"